var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.298,
    height: 13.625,
    viewBox: "0 0 8.298 13.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron",
    d: "M8.906-5.469,2.844.594a.723.723,0,0,1-.531.219A.723.723,0,0,1,1.781.594L1.094-.094A.782.782,0,0,1,.859-.625a.672.672,0,0,1,.2-.531L5.906-6,1.063-10.844a.672.672,0,0,1-.2-.531.782.782,0,0,1,.234-.531l.688-.687a.723.723,0,0,1,.531-.219.723.723,0,0,1,.531.219L8.906-6.531A.681.681,0,0,1,9.156-6,.681.681,0,0,1,8.906-5.469Z",
    transform: "translate(-0.858 12.813)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.b6ee631a2d710c57571b66e356360477.svg";
export { ForwardRef as ReactComponent };